import script from "./DataIngestionHistoryExportButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataIngestionHistoryExportButton.vue?vue&type=script&setup=true&lang=ts"

import "./DataIngestionHistoryExportButton.vue?vue&type=style&index=0&id=f2f4e5b6&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2f4e5b6"]])

export default __exports__